import { left, right, urlParamsStringToParamsObject } from "@/helpers/strings";

const setQueryParam = (route: any, router: any, paramName: string, paramValue: string) =>
{
    const query = Object.assign({}, route.query);
    query[paramName] = paramValue;
    
    router.replace({ query });
}

const deleteQueryParam = (route: any, router: any, paramName: string) =>
{
    const query = Object.assign({}, route.query);
    delete query[paramName];
    
    router.replace({ query });
}

const fromRouteNameToFullUrl = (router: any, routeName: string) =>
{
    const route = router.resolve({ name: routeName });
    const absoluteURL = new URL(route.href, window.location.href).href;

    return(absoluteURL);
}

const getRouteAddress = (url: string) =>
{
    let res;

    let path;
    let params;

    const indexOfQuestion = url.indexOf('?');
    if (indexOfQuestion >= 0) {
        const rightStringLength = url.length - (indexOfQuestion + 1);
        const paramsString = right(url, rightStringLength);
        
        path = left(url, indexOfQuestion);
        params = urlParamsStringToParamsObject(paramsString);

        res = {
            path: path,
            query: params,
        };
    }
    else {
        path = url;

        res = {
            path: path,
        };
    }

    return(res);
}

export
{
    setQueryParam,
    deleteQueryParam,
    fromRouteNameToFullUrl,
    getRouteAddress
}